export default function getHostname(state: any): string {
  return state.hostname;
}
